export const isBrandLayout = (categoria) => {
  return categoria?.slug_tree === 'brands' && categoria?.isolated_listing
}
